export const CAST_AI = 'Cast AI';

export const COPILOT = 'OpsPilot';
